var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessingPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 90,
    viewBox: "0 0 88 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 45C87 69.3218 67.7272 89 44 89C20.2728 89 1 69.3218 1 45C1 20.6782 20.2728 1 44 1C67.7272 1 87 20.6782 87 45Z",
    fill: "#EF3829",
    fillOpacity: 0.1,
    stroke: "url(#paint0_linear_626_2967)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_2967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1548 57.3351C60.5628 53.8022 63.7678 44.7963 60.3134 37.22C56.859 29.6436 48.0533 26.3658 40.6453 29.8987C33.2373 33.4316 30.0323 42.4374 33.4867 50.0138C36.9411 57.5902 45.7468 60.868 53.1548 57.3351Z",
    fill: "#E8E8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3868 42.7157L26.4636 39.9345L57.8724 38.1584L44.0397 53.5573L41.9669 55.7871L36.4797 61.9022L35.7585 48.7046L35.0579 48.136L33.8379 46.9123L30.6974 43.8962L29.3868 42.7157Z",
    fill: "#EF3829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4204 31.4327L35.9072 36.4465L36.3721 37.4661L46.8853 32.4523L46.4204 31.4327Z",
    fill: "#BBBEC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3334 43.2679L50.9893 46.2934L51.4541 47.313L57.7983 44.2875L57.3334 43.2679Z",
    fill: "#BBBEC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7756 62.551L36.0205 62.3469L36.0327 61.8897L35.3054 48.9208L34.78 48.4943L35.6078 47.6481L36.4353 48.4948L36.4291 48.7234L37.054 60.4998L40.97 56.2625L41.7551 57.0166L36.7756 62.551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5651 53.9838L43.7377 53.1371L56.6036 38.7635L27.9254 40.4787L29.846 42.271L29.1088 43.074L25.8776 40.1012L26.21 39.3784L26.5242 39.3414L58.2472 37.5283L58.5853 38.2698L58.3979 38.5849L44.5651 53.9838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1193 43.5306L30.374 44.358L33.5365 47.3378L34.2818 46.5104L31.1193 43.5306Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7518 37.6517L35.6379 48.198L36.1028 49.2176L58.2167 38.6713L57.7518 37.6517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8894 44.8928L26.3762 49.9066L26.8411 50.9262L37.3543 45.9124L36.8894 44.8928Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7524 40.6593L27.4958 43.1662L27.9607 44.1858L33.2173 41.6789L32.7524 40.6593Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4084 43.6849L25.3208 44.2035L25.7857 45.2231L26.8733 44.7045L26.4084 43.6849Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7256 51.2353L38.7532 55.5143L39.2181 56.5339L48.1905 52.2549L47.7256 51.2353Z",
    fill: "#090909"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_626_2967",
    x1: 62,
    y1: 7.67045,
    x2: -1.33455,
    y2: 67.1005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD4937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9287",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_2967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.1557,
    height: 38.7108,
    fill: "white",
    transform: "matrix(0.90261 -0.43046 0.414858 0.909886 18.7502 35.601)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingPayment);
export default __webpack_public_path__ + "static/media/processingPayment.b4305aa27092c7e099f9442461124d85.svg";
export { ForwardRef as ReactComponent };